import React, { CSSProperties } from 'react';
import { Eye } from 'lucide-react';
import { LivestreamStatusBadge } from './LivestreamStatusBadge';

interface Props {
  title?: string | null;
  streamStatus?: 'live' | 'disconnected' | 'ended' | null;
  hasVod: boolean;
  viewerCount?: number;
  hasImage?: boolean;
}

export function LivestreamInfoOverlay({
  title,
  streamStatus,
  hasVod,
  viewerCount = 0,
  hasImage = true,
}: Props): React.ReactElement {
  const isLive = streamStatus === 'live';
  const textColor = hasImage ? '#ffffff' : '#000000';
  const textShadow: CSSProperties = hasImage
    ? { textShadow: '0 2px 4px rgba(0, 0, 0, 0.9)' }
    : {};

  return (
    <div style={styles.container}>
      <div style={styles.topRow}>
        <LivestreamStatusBadge streamStatus={streamStatus} hasVod={hasVod} />
      </div>

      <div style={styles.content}>
        <h3
          style={{ ...styles.title, color: textColor, ...textShadow }}
          title={title || 'Live Stream'}>
          {title || 'Live Stream'}
        </h3>

        {isLive && viewerCount > 0 && (
          <div style={styles.viewerRow}>
            <Eye size={14} color={textColor} style={{ marginRight: 4 }} />
            <span style={{ ...styles.viewerText, color: textColor, ...textShadow }}>
              {viewerCount} watching
            </span>
          </div>
        )}
      </div>
    </div>
  );
}

const styles: Record<string, CSSProperties> = {
  container: {
    position: 'absolute',
    top: 0,
    left: 0,
    right: 0,
    bottom: 55,
    zIndex: 1,
    pointerEvents: 'none',
  },
  topRow: {
    position: 'absolute',
    top: 12,
    right: 12,
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
  },
  content: {
    padding: '16px',
    paddingRight: '60px',
    paddingTop: '16px',
  },
  title: {
    fontSize: '16px',
    fontWeight: 'bold',
    margin: 0,
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
  },
  viewerRow: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    marginTop: '6px',
  },
  viewerText: {
    fontSize: '13px',
    fontWeight: 500,
  },
};
